import React, { useState } from 'react';
import othersPhoto1 from '../img/others/o1.jpg';
import othersPhoto2 from '../img/others/o2.jpg';
import othersPhoto3 from '../img/others/o3.jpg';
import othersPhoto4 from '../img/others/o4.jpg';
import othersPhoto5 from '../img/others/o5.jpg';
import othersPhoto6 from '../img/others/o6.jpg';
import othersPhoto7 from '../img/others/o7.jpg';
import othersPhoto8 from '../img/others/o8.jpg';
import othersPhoto9 from '../img/others/o9.jpg';


export const OthersPortfolio = () => {

    const [imgActive, setImgActive] = useState(othersPhoto1);
    const photos = [othersPhoto1, othersPhoto2, othersPhoto3, othersPhoto4, othersPhoto5, othersPhoto6, othersPhoto7, othersPhoto8,othersPhoto9];
    const [selectedIndex, setSelectedIndex] = useState(0);
    
    const changeImg = (img, index) => {        
        setImgActive(img);
        setSelectedIndex(index);        
    }

    return (
        <div className = "row d-flex justify-content-center align-items-center">
            <div className = "col-6">                
                {                        
                    [0,1,2].map((e, index) => {
                        return (
                            <div className = "row justify-content-center" key={index}> 
                            {
                                photos.slice(3*e,3*e+3).map((d, index2) => {                      
                                    return (
                                        <div key = {(index2+(3*e))}className = "portfolio-img" onClick={()=> changeImg(d, (index2+(3*e)))}>                            
                                            <img src = {d} alt = "" className = "portfolio-img-prev"/>
                                            <div className = {selectedIndex ===  (index2+(3*e)) ? 'portfolio-img-prev-background-active' : 'portfolio-img-prev-background'}></div>
                                        </div>
                                    );
                                })
                            }
                            </div>
                        );
                    })                        
                }                
            </div>
            <div className = "col-6 p-0">
                <img src={imgActive} className = "gallery-img" alt = "gallery"/>
            </div>
        </div> 
    );
}

export const OthersPortfolioPhone = () => {
    
    const photos = [othersPhoto1, othersPhoto2, othersPhoto3, othersPhoto4, othersPhoto5, othersPhoto6, othersPhoto7, othersPhoto8,othersPhoto9];
    const [imgActive, setImgActive] = useState(othersPhoto1);
    const [selectedIndex, setIndex ] = useState('01'); 

    const changeImg = (img, index) => {
        setImgActive(img);
        setIndex((index+1).toString().padStart(2,'0'));
    }

    return (                
        <div className = "row">
            <div className = "p-0 mb-4 mt-4">
                <img src={imgActive} className = "gallery-img-phone" alt = "gallery"/>
            </div>
            <p className = "gallery-info-phone">{selectedIndex}/{photos.length.toString().padStart(2,'0')}</p>
            <div className = "mt-2 container-gallery-phone">            
                <div className = "row h-100 p-0">
                    <div className = "d-flex align-items-center">
                        {photos.map((d, index) => {
                            return (
                                <div key={index} className = "w-[5.8125rem] h-[4.8875rem]">
                                    <div className = "portfolio-img-phone" onClick={()=> changeImg(d, index)}>                            
                                        <img src = {d} alt = "" className = "portfolio-img-prev-phone"/>
                                        <div className = {selectedIndex ===  ((index+1).toString().padStart(2,'0')) ? 'portfolio-img-prev-background-active' : 'portfolio-img-prev-background'}></div>
                                    </div> 
                                </div>
                            );
                        })}                       
                    </div>                                                             
                </div>
            </div> 
        </div>                                               
    );
}